import { Checkbox } from "@mui/material";
import React from "react";
// import { useShippingContext } from "../../hooks";

const OutboundOrdersCheckbox = ({ item }) => {
  // const { onSelect = () => {}, ids } = useShippingContext();

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    // onSelect(item.id);
  };

  return (
    <Checkbox
      sx={{ padding: 0 }}
      // checked={ids.has(item.id)}
      onClick={handleClick}
    />
  );
};

export default OutboundOrdersCheckbox;
